// Shop — products from the creators and partners you follow and book (same endpoints as the app's Shop tab).
import { api, qs } from "@/lib/api";

export const shopApi = {
  categories: () => api("/shop/categories", { auth: false }),
  feed: (params) => api(`/shop/feed?${qs(params)}`),
  product: (id) => api(`/shop/products/${id}`),
  store: (sellerId) => api(`/shop/store/${sellerId}`),
  checkout: (id, body) => api(`/shop/products/${id}/checkout`, { method: "POST", body }),
  orderStatus: (sid) => api(`/shop/orders/status/${encodeURIComponent(sid)}`),
  myOrders: () => api("/shop/orders/mine"),
};

export function gbp2(v) {
  const n = Number(v || 0);
  return `£${n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)}`;
}
